import { BiLink } from "react-icons/bi";
import { BsCode, BsLayoutWtf } from "react-icons/bs";
import { IoOptions, IoSettings } from "react-icons/io5";
import { ActionIcon, Dropdown } from "rizzui";
import TrashIcon from "@/components/icons/trash";
import {
  E_LANDING_PAGE_TYPE,
  ILandingPage,
} from "@/utilities/types/LandingPage";
import { CustomizeDomainForm } from "../create-update/DomainConfigModal";
import { CustomizeDomainState, ProjectLandingGridListingStates } from "./types";
import { LuReplaceAll } from "react-icons/lu";

interface DropdownActionsProps {
  ldpData: ILandingPage;
  isAdmin: boolean;
  agentCanEdit: boolean;
  isSetupScript: boolean;
  handleDomainModal?: (
    data: Partial<CustomizeDomainForm> & CustomizeDomainState
  ) => void;
  handleEdit: () => void;
  handleScriptsModal?: (
    data: ProjectLandingGridListingStates["scriptsModal"]
  ) => void;
  handleOptionModal?: (
    data: ProjectLandingGridListingStates["modifyModal"]
  ) => void;
  handleReplaceLatestContent?: () => void;
  handleDelete: () => void;
}

export const DropdownActions: React.FC<DropdownActionsProps> = ({
  ldpData,
  isAdmin,
  agentCanEdit,
  isSetupScript,
  handleDomainModal,
  handleEdit,
  handleScriptsModal,
  handleOptionModal,
  handleDelete,
  handleReplaceLatestContent,
}) => {
  return (
    <Dropdown
      className="opacity-0 group-hover:opacity-100 absolute right-2 top-2"
      placement="bottom-end"
      rounded="md"
    >
      <Dropdown.Trigger>
        <ActionIcon size="sm" rounded="md">
          <IoSettings />
        </ActionIcon>
      </Dropdown.Trigger>
      <Dropdown.Menu className="divide-y min-w-max">
        <Dropdown.Item
          onClick={() => {
            const activeDomain =
              ldpData.type === E_LANDING_PAGE_TYPE.SUBDOMAIN
                ? ldpData.subDomain
                : ldpData.customDomain;
            handleDomainModal?.({
              id: ldpData.id,
              domain: activeDomain,
              domainName: ldpData.name,
              isInactiveUser: ldpData?.user?.statusAccount === "inactive",
              projectId: ldpData.project?.id,
              isSetupScript: isSetupScript,
              useProjectSgTrackingId: !!ldpData?.useProjectSgTrackingId,
              cNameTargetDomain: ldpData?.cNameTargetDomain,
              type: ldpData?.type || E_LANDING_PAGE_TYPE.CUSTOM,
              subDomain: ldpData?.subDomain,
              customDomain: ldpData?.customDomain,
              cNameTarget: ldpData?.cNameTarget,
            });
          }}
        >
          <BiLink className="mr-2 h-4 w-4" />
          Domain Config
        </Dropdown.Item>

        <Dropdown.Item onClick={handleEdit}>
          <BsLayoutWtf className="mr-2 h-4 w-4" />
          Editor Layout
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() => {
            handleScriptsModal?.({
              ldpId: ldpData.id,
              open: true,
              initialValues: {
                headerScript: ldpData.headerScript,
                bodyScript: ldpData.bodyScript,
                enquiryScript: ldpData.enquiryScript,
                useEnquiryScript: !!ldpData?.useEnquiryScript,
                conversionId: ldpData.dataScript?.conversionId,
                conversionLabel: ldpData.dataScript?.conversionLabel,
                pixelID: ldpData.dataScript?.pixelID,
              },
              useProjectSgTrackingId: !!ldpData?.useProjectSgTrackingId,
            });
          }}
        >
          <BsCode className="mr-2 h-4 w-4" />
          Setup Scripts
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() =>
            handleOptionModal?.({
              ldpId: ldpData.id,
              optionMappings: ldpData.optionMappings,
              open: true,
            })
          }
        >
          <IoOptions className="mr-2 h-4 w-4" />
          Modify Option
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleReplaceLatestContent?.()}>
          <LuReplaceAll className="mr-2 h-4 w-4" />
          Replace Latest Content
        </Dropdown.Item>

        {(isAdmin || agentCanEdit) && (
          <Dropdown.Item onClick={handleDelete}>
            <TrashIcon className="mr-2 h-4 w-4" />
            Delete
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
